// Import local assets
import chickenCurryImg from '../assets/chicken curry.jpg';
import chaiMasala1Img from '../assets/chai masala1.jpg';
import desiChanaImg from '../assets/desi chana.jpg';
import pavBhajiImg from '../assets/pav bhaji masala.jpg';
import kolhapuriImg from '../assets/kolhapuri mix.jpg';
import fishFryImg from '../assets/red chilli paste.jpg';
import paneerImg from '../assets/paneer1.jpg';
import biryaniImg from '../assets/chicken biryani.jpg';
import chickenImg from '../assets/chicken.jpg';

export const recipesData = [
  {
    id: 1,
    name: 'Delhi Style Chicken',
    category: 'Main Course',
    time: '45 min',
    difficulty: 'Medium',
    masala: 'Delhi Style Butter Chicken Masala',
    img: chickenCurryImg,
    date: 'September 8, 2023',
    views: '22.9K',
    likes: 201,
    description: 'A velvety tomato-based gravy enriched with our specialized Delhi-style blend.',
    ingredients: {
      "Main": ["500g Chicken", "2 tbsp Butter", "1/2 Cup Cream"],
      "Spices": ["2 tbsp Ragini Delhi Style Butter Chicken Masala", "1 tbsp Ragini Ginger Garlic Paste"]
    },
    instructions: [
      { step: "Prep", text: "Marinate chicken with Ragini Ginger Garlic Paste and salt." },
      { step: "Gravy", text: "Cook tomato puree in butter, add Delhi Style Butter Chicken Masala." },
      { step: "Combine", text: "Add chicken and simmer until tender. Finish with cream." }
    ]
  },
  {
    id: 2,
    name: 'Masala Chai',
    category: 'Beverage',
    time: '15 min',
    difficulty: 'Easy',
    masala: 'Chai masala',
    img: chaiMasala1Img,
    date: 'October 12, 2023',
    views: '15.4K',
    likes: 145,
    description: 'An aromatic sponge infused with our signature cardamom-forward tea blend.',
    ingredients: {
      "Base": ["2 Cups Flour", "1 Cup Sugar", "1/2 Cup Butter"],
      "Flavor": ["2 tbsp Ragini Chai masala", "1/2 Cup Milk"]
    },
    instructions: [
      { step: "Mix", text: "Sift flour with Ragini Chai masala." },
      { step: "Bake", text: "Bake at 180°C for 35 minutes." }
    ]
  },
  {
    id: 4,
    name: 'Amritsari Chhole',
    category: 'Main Course',
    time: '60 min',
    difficulty: 'Medium',
    masala: 'Chole Masala',
    img: desiChanaImg,
    date: 'September 8, 2023',
    views: '22.9K',
    likes: 201,
    description: 'Dark, spicy chickpeas cooked with authentic Amritsari Chole Masala.',
    ingredients: {
      "Base": ["2 Cups Chickpeas", "2 Onions"],
      "Spices": ["2 tbsp Ragini Chole Masala", "1 tsp Ragini Turmeric Powder"]
    },
    instructions: [
      { step: "Boil", text: "Boil chickpeas with salt." },
      { step: "Cook", text: "Sauté onions, add Ragini Chole Masala and chickpeas. Simmer." }
    ]
  },
  {
    id: 5,
    name: 'Mumbai Pav Bhaji',
    category: 'Main Course',
    time: '40 min',
    difficulty: 'Easy',
    masala: 'Mumbai Style Pav Bhaji Masala',
    img: pavBhajiImg,
    date: 'January 15, 2024',
    views: '35.2K',
    likes: 420,
    description: 'The iconic Mumbai street food made with our specialized Mumbai-style blend.',
    ingredients: {
      "Veg": ["Potatoes", "Peas", "Cauliflower"],
      "Spices": ["3 tbsp Butter", "2 tbsp Ragini Mumbai Style Pav Bhaji Masala"]
    },
    instructions: [
      { step: "Mash", text: "Mash boiled veggies." },
      { step: "Sauté", text: "Cook with butter and Ragini Mumbai Style Pav Bhaji Masala." }
    ]
  },
  {
    id: 7,
    name: 'Veg Kolhapuri',
    category: 'Main Course',
    time: '45 min',
    difficulty: 'Hard',
    masala: 'Kolhapuri Masala',
    img: kolhapuriImg,
    date: 'March 5, 2024',
    views: '18.4K',
    likes: 230,
    description: 'Fiery vegetable curry made with the bold Kolhapuri Masala.',
    ingredients: {
      "Veg": ["Mixed Vegetables", "Paneer"],
      "Spices": ["2 tbsp Ragini Kolhapuri Masala", "1 tbsp Ragini Ginger Garlic Paste"]
    },
    instructions: [
      { step: "Cook", text: "Sauté veg, add Kolhapuri Masala and simmer until spicy and rich." }
    ]
  },
  {
    id: 8,
    name: 'Coastal Fish Fry',
    category: 'Main Course',
    time: '20 min',
    difficulty: 'Medium',
    masala: 'Coastal Fish Fry Masala',
    img: fishFryImg,
    date: 'April 12, 2024',
    views: '25.9K',
    likes: 310,
    description: 'Crispy fried fish with the tang of the coast.',
    ingredients: {
      "Fish": ["500g Fish"],
      "Spices": ["2 tbsp Ragini Coastal Fish Fry Masala", "Oil"]
    },
    instructions: [
      { step: "Fry", text: "Coat fish with Ragini Coastal Fish Fry Masala and shallow fry." }
    ]
  },
  {
    id: 11,
    name: 'Paneer Tikka Masala',
    category: 'Main Course',
    time: '40 min',
    difficulty: 'Medium',
    masala: 'Classic Paneer Masala',
    img: paneerImg,
    date: 'June 10, 2024',
    views: '28.4K',
    likes: 380,
    description: 'Creamy paneer curry made with our classic paneer blend.',
    ingredients: {
      "Main": ["Paneer", "Capsicum"],
      "Spices": ["2 tbsp Ragini Classic Paneer Masala"]
    },
    instructions: [
      { step: "Grill", text: "Grill paneer, then simmer in a gravy made with Classic Paneer Masala." }
    ]
  },
  {
    id: 12,
    name: 'Hyderabadi Dum Biryani',
    category: 'Main Course',
    time: '60 min',
    difficulty: 'Hard',
    masala: 'Dum Biryani Special Masala',
    img: biryaniImg,
    date: 'June 15, 2024',
    views: '45.2K',
    likes: 620,
    description: 'The ultimate aromatic rice celebration.',
    ingredients: {
      "Rice": ["Basmati Rice"],
      "Spices": ["3 tbsp Ragini Dum Biryani Special Masala"]
    },
    instructions: [
      { step: "Layer", text: "Layer rice and meat with Ragini Dum Biryani Special Masala and cook on Dum." }
    ]
  },
  {
    id: 14,
    name: 'Royal Chicken Korma',
    category: 'Main Course',
    time: '50 min',
    difficulty: 'Medium',
    masala: 'Royal Chicken Masala',
    img: chickenImg,
    date: 'July 10, 2024',
    views: '12K',
    likes: 150,
    description: 'A regal, creamy chicken curry for special occasions.',
    ingredients: {
      "Main": ["Chicken", "Cashew Paste"],
      "Spices": ["2 tbsp Ragini Royal Chicken Masala"]
    },
    instructions: [
      { step: "Cook", text: "Simmer chicken in cashew gravy with Ragini Royal Chicken Masala." }
    ]
  }
];
